import { useMemo } from "react";
import { AvatarBlock, Spinner, SkeletonLoader, Text, type AvatarBlockProps, Stack } from "@bookingcom/bui-react";
import { PersonHalfIcon } from "@bookingcom/bui-assets-react/streamline";

type HeaderAvatarProps = {
  name?: string;
  email?: string;
  avatarUrl?: string;
  isLoading?: boolean;
};

export const HeaderAvatar = ({ name, email, avatarUrl, isLoading = false }: HeaderAvatarProps) => {
  const avatarBlockProps: AvatarBlockProps = useMemo(() => {
    if (isLoading) {
      return {
        title: <SkeletonLoader variant="title" color="inherit" width={30} />,
        subtitle: <SkeletonLoader variant="one-line" color="inherit" width={30} mixin={{ marginBlockStart: 1.5 }} />,
        avatar: { icon: <Spinner size="small" />, outline: "accent" },
      };
    }

    return {
      title: (
        <Text variant="strong_2" color="white">
          {name}
        </Text>
      ),
      subtitle: (
        <Text variant="small_1" color="brand_genius_secondary">
          {email}
        </Text>
      ),
      avatar: avatarUrl ? { src: avatarUrl, outline: "accent" } : { icon: <PersonHalfIcon />, outline: "accent" },
    };
  }, [name, email, avatarUrl, isLoading]);

  return (
    <Stack alignItems="end" justifyContent="center">
      <AvatarBlock size="medium" color="inherit" {...avatarBlockProps} />
    </Stack>
  );
};
